import * as checked from 'reporting-data/lib/checked';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { Order } from '../../field/order';
//@ts-expect-error Untyped import
import { LegendPosition, LegendWidth } from '../commonRecords';
import { VisualizationTypes } from 'reporting-data/tsTypes/visualization';
import { Encoding, EncodingOptions } from '../formatting/FormattingRecords';
export const Events = checked.record({
  onPointClick: checked.func().optional()
}, 'Events');
export const Angle = checked.record({
  field: checked.string()
}, 'Angle');
export const SlicedPoint = checked.record({
  name: checked.string(),
  y: checked.any().fromJS(),
  color: checked.string(),
  sliceRow: checked.any().fromJS(),
  accessibilityLabel: checked.string()
}, 'Point');
export const SlicedColorEncoding = checked.record({
  field: checked.string().optional(),
  order: Order.optional(),
  defined: checked.map(checked.string()).optional(),
  default: checked.string().optional(),
  definedPatterns: checked.map(checked.string()).optional()
}, 'SlicedColorEncoding');
export const SlicedLayer = checked.record({
  dataset: checked.string(),
  name: checked.string().optional(),
  angle: Angle,
  color: SlicedColorEncoding,
  style: checked.map().defaultValue({}),
  colorFormattingOptions: EncodingOptions.optional(),
  valueFormattingOptions: checked.list(Encoding).optional(),
  grandTotalColumn: checked.string().optional()
}, 'SlicedLayer');
export const SlicedChartOptions = checked.record({
  type: checked.string(),
  dataLabels: checked.boolean().optional(),
  legendPosition: LegendPosition.optional(),
  legendWidth: LegendWidth.optional(),
  showTotals: checked.boolean().optional(),
  grandTotal: checked.number().optional(),
  tooltipDisabled: checked.boolean().optional(),
  disableSeriesHighlighting: checked.boolean().optional(),
  dateResolution: checked.string().optional()
}, 'SlicedChartOptions');
export const SlicedChartSeries = checked.record({
  name: checked.string(),
  points: checked.list(SlicedPoint),
  dataLabelPointFormatter: checked.func(),
  events: checked.map(),
  innerSize: checked.string()
}, 'SlicedChartSeries');
export const SlicedChart = checked.record({
  series: checked.list(),
  options: SlicedChartOptions
}, 'SlicedChart');
export const SlicedStyle = checked.record({
  dataLabels: checked.boolean().optional(),
  showLegend: checked.boolean().optional(),
  colors: checked.list().optional(),
  bottomLegend: checked.boolean().optional(),
  legendPosition: LegendPosition.optional(),
  legendWidth: LegendWidth.optional(),
  showTotals: checked.boolean().optional(),
  tooltipDisabled: checked.boolean().optional(),
  isMobile: checked.boolean().optional(),
  dateResolution: checked.string().optional()
}, 'SlicedStyle');
export const SlicedVisualization = checked.record({
  type: checked.string().always(VisualizationTypes.SLICED),
  data: checked.map(Dataset),
  layer: SlicedLayer,
  events: Events.optional(),
  style: SlicedStyle.optional(),
  isGrouped: checked.boolean().optional(),
  grandTotal: checked.number().optional()
}, 'SlicedVisualization');